import React, { use } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import { CardActionArea, CardActions } from "@mui/material";

const CollectionCard = (props) => {
  const navigate = useNavigate();
  const handleClick = () => {
    localStorage.setItem("categoryImage", props.cardData.image);
    localStorage.setItem("categoryTitle", props.cardData.title);
    navigate("/collection?collectionId=" + props.cardData.slug);
  };

  return (
    <Card sx={{ maxWidth: 265 }}>
      <ButtonBase onClick={() => handleClick()}>
        <CardActionArea>
          <CardMedia
            component="img"
            style={{ minHeight: 265 }}
            width="265"
            height="265"
            image={props.cardData.image}
            alt="TVPros"
          />
          <CardContent
              sx={{
                minHeight: "75px !important",
                marginTop:3,
                padding: 0,
              }}
          >
            <Typography
              gutterBottom
              variant="h6"
              component="div"
              color="secondary"
            >
              {props.cardData.title}
            </Typography>
            {props.cardData.description && (
              <Typography
                p={1}
                variant="subtitle1"
                style={{
                  fontSize: "1.15em",
                  textAlign: "center",
                }}
              >
                {props.cardData.description}
              </Typography>
            )}
          </CardContent>
        </CardActionArea>
      </ButtonBase>
    </Card>
  );
};

export default CollectionCard;
